const config = {
	testUrl: 'https://showel-backend.herokuapp.com/api/v1',
	liveUrl: 'https://showel-backend.herokuapp.com/api/v1',
}

export default config
